var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_2","data-name":"Path 2","d":"M304.064,224.432,286.9,207.271l17.161-17.161","transform":"translate(-284.497 -188.907)","fill":"none","stroke":"currentColor","strokeMiterlimit":"10","strokeWidth":"3.402"}));
}

ArrowInline.defaultProps = {"width":"20.769","height":"36.728","viewBox":"0 0 20.769 36.728"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
